import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  StateSchema,
  assign
} from "xstate4"
import {
  Context,
  Transitions,
  ConfirmResetRestoerMasteryLessonSchema
} from "../../types"
import { getResetClassMasteryLessonsAffectedCountTransition } from "../teacher/transitionalStates/getResetClassMasteryLessonsAffectedCount"

export const openConfirmRestoreMasteryLesson: StateNodeConfig<
  Context,
  ConfirmResetRestoerMasteryLessonSchema,
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({
    openConfirmRestoreMasteryLesson: true,
    currentClassMasteryLessonAffectedCount: null
  }),
  exit: assign<Context>({
    openConfirmRestoreMasteryLesson: false
  }),
  initial: "loading",
  states: {
    loading: {
      ...getResetClassMasteryLessonsAffectedCountTransition
    },
    idle: {
      on: {
        RESTORE_MASTERY_LESSON: {
          target: "#StudyPlan.teacher_view.restore_mastery_lesson_transition"
        },
        CANCEL: {
          target: "#StudyPlan.teacher_view.idle",
          actions: assign<Context>({
            selectedLessonId: null,
            selectedSectionId: null
          })
        }
      }
    }
  }
}
